module.exports = __webpack_public_path__ + "img/GBAFOA.4a1b3faf.png";